import { useAdminContractDetailPageProps } from "./fetch";
import { AdminContractDetailPageUi } from "./ui";

export const AdminContractDetailPage: React.FC<{
  contractId?: string;
}> = ({ contractId }) => {
  const props = useAdminContractDetailPageProps(contractId);
  return <AdminContractDetailPageUi {...props} />;
};
